import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { ConfigService } from '../config.service';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, of } from 'rxjs';
import { NotificacionModel } from '../../models/notificacion/notificacion.model';


@Injectable({
  providedIn: 'root'
})
export class NotificacionesService {

  private url = this.configService.config.servidor?.api_cart;
  private baseUrl = this.configService.config.servidor?.api_server;
  private accessToken: string = this.authService.usuario.token;

  // MC VENDU-612 BehaviorSubject para refrescar el listado de notificaciones y mantenerlo actualizado
  public refreshListado: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  
  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthService,) { }

  getNotificaciones(parametros:Object){
    // const url = `${this.baseUrl}/NotificacionHistorial`; //PM CATFER-12 
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.NOTIFICACION_HISTORIAL.VERSION + this.configService.resource.NOTIFICACION_HISTORIAL.PATH_BASE;
    let params = {};
    {Object.assign(params, parametros);}
    return this.http.get<NotificacionModel>(url, {params: params});
  }

  pathNotificaciones(id_Notif: number, notif: any ){
    // const url = `${this.baseUrl}/NotificacionHistorial/${id_Notif}`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.NOTIFICACION_HISTORIAL.PATCH_NOTIFICACIONES.VERSION + this.configService.resource.NOTIFICACION_HISTORIAL.PATH_BASE + this.configService.resource.NOTIFICACION_HISTORIAL.PATCH_NOTIFICACIONES.PATH_REL.replace('{id_notificacion}', id_Notif);
    return this.http.patch<NotificacionModel>(url, notif);
  }

  // MC CATFER-119 Creación de notificación
  postNotificacion(datos: any) {
    const url = this.baseUrl + this.configService.resource.NOTIFICACION.VERSION + this.configService.resource.NOTIFICACION.PATH_BASE;
    return this.http.post<any>(url, datos);
  }

  // MC CATFER-119 Obtener listado de NotificacionConfiguracion
  getNotificacionConfiguracion(params: any) {
    const url = this.baseUrl + this.configService.resource.NOTIFICACION_CONFIGURACION.VERSION + this.configService.resource.NOTIFICACION_CONFIGURACION.PATH_BASE;
    return this.http.get<any>(url, {params});
  }
}
